import React from 'react'
import Skeleton from '../Skeleton'
import { GeometricBackground } from '../layouts/GeometricBackground'

const AppSkeleton = () => {
    return (
        <div className="min-h-screen bg-[#030303] overflow-x-hidden relative">
            <GeometricBackground variant="home" className="fixed inset-0" />

            {/* Desktop Top Navigation Skeleton */}
            <nav className="hidden lg:block fixed top-0 w-full z-40 backdrop-blur-md bg-white/5 ring-1 ring-white/5">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        {/* Logo */}
                        <div className="flex items-center space-x-2">
                            <Skeleton className="h-8 w-8 rounded-lg bg-white/10" />
                            <Skeleton className="h-6 w-24 bg-white/10" />
                        </div>

                        {/* Desktop Navigation */}
                        <div className="flex items-baseline space-x-4">
                            {[1, 2, 3, 4, 5, 6].map((i) => (
                                <Skeleton key={i} className="h-9 w-24 rounded-xl bg-white/10" />
                            ))}
                        </div>

                        {/* Right side - User menu and theme toggle */}
                        <div className="flex items-center space-x-4">
                            <Skeleton className="h-9 w-9 rounded-xl bg-white/10" />
                            <div className="flex items-center space-x-3">
                                <Skeleton className="h-8 w-8 rounded-full bg-white/10" />
                                <div className="hidden xl:block space-y-1">
                                    <Skeleton className="h-3 w-24 bg-white/10" />
                                    <Skeleton className="h-3 w-32 bg-white/10" />
                                </div>
                                <Skeleton className="h-8 w-8 rounded-full bg-white/10" />
                            </div>
                        </div>
                    </div>
                </div>
            </nav>

            {/* Mobile Header Skeleton */}
            <header className="lg:hidden fixed top-0 left-0 right-0 backdrop-blur-md bg-white/5 z-30 ring-1 ring-white/5">
                <div className="flex items-center justify-between px-4 py-2">
                    <div className="flex items-center space-x-2">
                        <Skeleton className="h-8 w-8 rounded-lg bg-white/10" />
                        <Skeleton className="h-5 w-20 bg-white/10" />
                    </div>

                    <div className="flex items-center space-x-3">
                        <Skeleton className="h-8 w-8 rounded-xl bg-white/10" />
                        <Skeleton className="h-8 w-8 rounded-xl bg-white/10" />
                    </div>
                </div>
            </header>

            {/* Main Content Skeleton */}
            <main
                className="relative z-10 flex-1 lg:pb-0 pt-16 lg:pt-20"
                style={{
                    paddingBottom: 'calc(56px + 8px)' // Approximate mobile nav height
                }}
            >
                <div className="p-6 max-w-7xl mx-auto">
                    {/* Header */}
                    <div className="mb-6 lg:mb-8 mt-6 lg:mt-20">
                        <Skeleton className="h-8 w-48 mb-2 bg-white/10" />
                        <Skeleton className="h-4 w-64 bg-white/10" />
                    </div>

                    {/* Stats Grid */}
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6 mb-6">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="glass-card p-4 lg:p-6 h-24 lg:h-32">
                                <Skeleton className="h-4 w-20 mb-2 bg-white/10" />
                                <Skeleton className="h-8 w-32 bg-white/10" />
                            </div>
                        ))}
                    </div>

                    {/* Content Block */}
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                        <div className="glass-card p-6 h-64">
                            <Skeleton className="h-full w-full rounded-lg bg-white/5" />
                        </div>
                        <div className="glass-card p-6 h-64">
                            <Skeleton className="h-full w-full rounded-lg bg-white/5" />
                        </div>
                    </div>
                </div>
            </main>

            {/* Mobile Bottom Navigation Skeleton */}
            <nav
                className="lg:hidden fixed bottom-0 left-0 right-0 backdrop-blur-md bg-black/20 border-t border-white/10 z-30"
                style={{
                    paddingBottom: '8px'
                }}
            >
                <div className="grid grid-cols-3 h-14">
                    {[1, 2, 3].map((i) => (
                        <div key={i} className="flex flex-col items-center justify-center space-y-1">
                            <Skeleton className="h-5 w-5 rounded-full bg-white/10" />
                            <Skeleton className="h-2 w-10 bg-white/10" />
                        </div>
                    ))}
                </div>
            </nav>
        </div>
    )
}

export default AppSkeleton
